import React, { useState } from 'react';
import CoffeeSlider from './components/CoffeeSlider';
import OrderModal from './components/OrderModal';
import OrderConfirmation from './components/OrderConfirmation';
import { saveOrder } from './utils/orderUtils';
import './App.css';

function App() {
  const [selectedCoffee, setSelectedCoffee] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [lastOrder, setLastOrder] = useState(null);

  const handleSelectCoffee = (coffee) => {
    setSelectedCoffee(coffee);
  };

  const handleCloseModal = () => {
    setSelectedCoffee(null);
  };

  const handlePlaceOrder = (orderDetails) => {
    // Save order
    const order = saveOrder(orderDetails);
    setLastOrder(order);
    
    // Close modal
    setSelectedCoffee(null);
    
    // Show confirmation
    setShowConfirmation(true);
    
    // Return to home after 5 seconds
    setTimeout(() => {
      setShowConfirmation(false);
      setLastOrder(null);
    }, 5000);
  };

  return (
    <div className="App">
      {!showConfirmation ? (
        <CoffeeSlider onSelectCoffee={handleSelectCoffee} />
      ) : (
        <OrderConfirmation order={lastOrder} />
      )}
      
      {selectedCoffee && (
        <OrderModal
          coffee={selectedCoffee}
          onClose={handleCloseModal}
          onOrder={handlePlaceOrder}
        />
      )}
    </div>
  );
}

export default App;
